var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeoYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.344 10.0667C19.1326 8.17398 18.2839 6.40944 16.9372 5.06279C15.5906 3.71613 13.826 2.86742 11.9333 2.656V1.66667C11.9333 1.15334 11.5133 0.733337 11 0.733337C10.4867 0.733337 10.0667 1.15334 10.0667 1.66667V2.656C8.17398 2.86742 6.40944 3.71613 5.06279 5.06279C3.71613 6.40944 2.86742 8.17398 2.656 10.0667H1.66667C1.15334 10.0667 0.733337 10.4867 0.733337 11C0.733337 11.5133 1.15334 11.9333 1.66667 11.9333H2.656C2.86742 13.826 3.71613 15.5906 5.06279 16.9372C6.40944 18.2839 8.17398 19.1326 10.0667 19.344V20.3333C10.0667 20.8467 10.4867 21.2667 11 21.2667C11.5133 21.2667 11.9333 20.8467 11.9333 20.3333V19.344C13.826 19.1326 15.5906 18.2839 16.9372 16.9372C18.2839 15.5906 19.1326 13.826 19.344 11.9333H20.3333C20.8467 11.9333 21.2667 11.5133 21.2667 11C21.2667 10.4867 20.8467 10.0667 20.3333 10.0667H19.344ZM11 17.5333C7.388 17.5333 4.46667 14.612 4.46667 11C4.46667 7.388 7.388 4.46667 11 4.46667C14.612 4.46667 17.5333 7.388 17.5333 11C17.5333 14.612 14.612 17.5333 11 17.5333Z",
    fill: "#FFB100"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 3.73333,
    fill: "#FFB100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeoYellow);
export default __webpack_public_path__ + "static/media/geo-yellow.1200787060b7e80b089bdc2cbcc6f452.svg";
export { ForwardRef as ReactComponent };